import { Component, HostBinding } from '@angular/core';
import { Endpoint, HelpIndex, SettingsType } from '../../../../models/enums';
import { GenericColDef, GridContext, SortByFilter } from '../../../../models/grid-context';
import * as _ from 'underscore';
import { SettingsNavigationContentComponent } from '../../../../models/settings-navigation-content-component';
import { GenericTreeNode } from '../../../generic-tree/generic-tree-node';

@Component({
    standalone: false,
    selector: 'res-license',
    templateUrl: './license.component.html',
    styleUrls: ['./license.component.scss']
})
export class LicenseComponent implements SettingsNavigationContentComponent {
    @HostBinding('class') classes = 'maximized-component';

    automationId = 'license';
    isDirty: boolean;
    validChanges: boolean;
    gridName = 'License';

    isBusy = false;
    isBusyMessage = 'Loading License...';
    helpIndex = HelpIndex.sys_license_dlg;
    gridContext = new GridContext({ sortBy: SortByFilter.NAME, sortAscending: true, sortEnabled: false });

    requestInfo = {
        endpoint: Endpoint.realmManager_getLicenseInfo,
        responseName: 'info',
        data: { systemScope: true }
    };

    columnDefs = new Array<GenericColDef>(
        {
            headerName: 'Label',
            field: 'label',
            lockVisible: true,
            automationId: this.automationId,

        },
        {
            headerName: 'Value',
            field: 'value',
            automationId: this.automationId,
        }
    );

    responseCallback = (response: any) => {
        if (response?.info) {
            const excludedInfoList = ['Version', 'License type', 'Lotus'];
            response.info = response.info.filter(item => !excludedInfoList.includes(item.label));
        }
    }

    responseArrayCallback = (value: any) => {
        const renameLabelsList = ['Number of Express Analytic Engine cores', 'Number of OCR Analytic Engine cores']
        if (value?.label && renameLabelsList.includes(value.label)) {
            value.label = value.label.replace('Analytic Engine ', '');
        }
        return value;
    }

    saveChanges(): Promise<boolean> {
        return Promise.resolve(true);
    }

    selectedTreeItemChanged(node: GenericTreeNode, projectHandle?: string, settingsType?: SettingsType): void {
        return;
    }

}